// extracted by mini-css-extract-plugin
export default {"container":"Error404_container__2ihxb","error":"Error404_error__QDfE5"};